import { lazy } from 'react'

// Billing analytics tabs
export const BillingPage = lazy(() =>
  import('@features/billing').then((module) => ({ default: module.BillingPage }))
)
export const BillingRevenueTab = lazy(() =>
  import('@features/billing').then((module) => ({ default: module.BillingRevenueTab }))
)
export const BillingUsageTab = lazy(() =>
  import('@features/billing').then((module) => ({ default: module.BillingUsageTab }))
)
export const BillingSubscribersTab = lazy(() =>
  import('@features/billing').then((module) => ({ default: module.BillingSubscribersTab }))
)
export const BillingTrialsTab = lazy(() =>
  import('@features/billing').then((module) => ({ default: module.BillingTrialsTab }))
)
export const BillingChurnTab = lazy(() =>
  import('@features/billing').then((module) => ({ default: module.BillingChurnTab }))
)
export const BillingCollectionsTab = lazy(() =>
  import('@features/billing').then((module) => ({ default: module.BillingCollectionsTab }))
)
export const BillingSettingsPage = lazy(() =>
  import('@features/billing/pages/BillingSettingsPage').then((m) => ({
    default: m.BillingSettingsPage,
  }))
)

// Billing Schedules
export const BillingSchedulesListPage = lazy(() => import('@features/billing-schedules/pages/BillingSchedulesListPage'))
export const BillingScheduleDetailsPage = lazy(() =>
  import('@features/billing-schedules/pages/BillingScheduleDetailsPage')
)

// Usage-Based Billing
export const UsageBasedBillingPage = lazy(() => import('@features/usage-based-billing/pages/UsageBasedBillingPage').then((module) => ({
  default: module.UsageBasedBillingPage,
})))

// Revenue Recognition
export const RevenueRecognitionPage = lazy(() =>
  import('@shared/components/pages/revenue-recognition-page')
)
export const RevRecRuleDetailPage = lazy(() =>
  import('@features/revenue-recognition/pages/RevRecRuleDetailPage')
)
export const RevRecSettingsPage = lazy(() =>
  import('@features/revenue-recognition/pages/RevRecSettingsPage')
)

// Invoices
export const InvoicesListPage = lazy(() => import('@features/invoices/pages/InvoicesListPage'))
export const InvoiceDetailsPage = lazy(() =>
  import('@features/invoices/pages/InvoiceDetailsPage')
)
export const CreateInvoicePage = lazy(() => import('@features/invoices/pages/CreateInvoicePage'))
export const InvoiceWizardPage = lazy(() =>
  import('@features/invoices/pages/InvoiceWizardPage').then((m) => ({
    default: m.InvoiceWizardPage,
  }))
)

// Quotes
export const QuotesListPage = lazy(() => import('@features/quotes/pages/QuotesListPage'))
export const QuoteDetailsPage = lazy(() => import('@features/quotes/pages/QuoteDetailsPage'))
export const CreateQuotePage = lazy(() => import('@features/quotes/pages/CreateQuotePage'))

// Subscriptions
export const SubscriptionsPage = lazy(() =>
  import('@features/subscriptions/pages/SubscriptionsPage')
)
export const SubscriptionDetailsPage = lazy(() =>
  import('@features/subscriptions/pages/subscriptions/SubscriptionDetailsPage')
)
export const PricingTableDetailsPage = lazy(() =>
  import('@features/subscriptions/pages/pricing-table/PricingTableDetailsPage')
)
export const PlanDetailsPage = lazy(() =>
  import('@features/subscriptions/pages/plans/PlanDetailsPage')
)

// Balances
export const BalancesPage = lazy(() => import('@shared/components/pages/balances-page'))
export const CryptoBalancesPage = lazy(() => import('@shared/components/pages/balances-page'))
export const BalancePage = lazy(() => import('@features/money-movement/pages/BalancePage'))
export const BalanceActivityPage = lazy(() => import('@features/money-movement/pages/BalancePage'))
export const BalanceInvoicesPage = lazy(() => import('@features/money-movement/pages/BalancePage'))
export const BalanceSalesPage = lazy(() => import('@features/money-movement/pages/BalancePage'))
export const BalancePayoutsPage = lazy(() => import('@features/money-movement/pages/BalancePage'))
export const BalanceReservesPage = lazy(() => import('@features/money-movement/pages/BalancePage'))
export const BalanceHubPage = lazy(() => import('@features/balance-hub/pages/BalanceHubPage'))
export const BalanceActivityDetailPage = lazy(() => import('@features/balance-hub/pages/BalanceActivityDetailPage'))
export const WalletDetailPage = lazy(() => import('@features/balance-hub/pages/WalletDetailPage'))
